import { faList, faCheckCircle, faFilter } from '@fortawesome/pro-light-svg-icons'

import { FormField, InputSearch, SegmentedControl } from '@domain-group/suit-theme'

import useAssignEntityPermissionsModal from '@hooks/useAssignEntityPermissionsModal'

interface EntityFiltersProps {
  assignLayoutTemplatePermissionsPayload: ReturnType<typeof useAssignEntityPermissionsModal>,
}

const EntityFilters = (props: EntityFiltersProps) => {
  const {
    assignLayoutTemplatePermissionsPayload: {
      activeSegmentKey,
      callbacks: {
        setCurrentSegmentKey,
        setState,
      },
      filterString,
    },
  } = props

  return (
    <>
      <FormField label="Filter Products">
        {/*
         // @ts-expect-error TS2741 */}
        <InputSearch
          // @ts-expect-error TS7006
          onChange={e => setState({ filterString: e.target.value })}
          value={filterString}
        />
      </FormField>

      <SegmentedControl
        activeButtonKey={filterString ? 'filtered' : activeSegmentKey}
        boxProps={{ marginTop: 'medium' }}
        buttons={[
          {
            key: 'all',
            // @ts-expect-error TS2322
            icon: faList,
            label: 'All Items',
          },
          {
            key: 'selected',
            // @ts-expect-error TS2322
            icon: faCheckCircle,
            label: 'Selected Items',
          },
          {
            disabled: !filterString,
            key: 'filtered',
            // @ts-expect-error TS2322
            icon: faFilter,
            label: 'Filtered Items',
          },
        ]}
        onClick={key => setCurrentSegmentKey(key)}
      />
    </>
  )
}

export default EntityFilters
